import { FC } from 'react'
import { TagInput as RsuiteTagInput, TagInputProps } from 'rsuite'

const checkIfLastItemAlreadyExist = (
  item: string,
  index: number,
  list: ReadonlyArray<string>
): boolean =>
  index < list.length - 1 &&
  item.toLowerCase() === list[list.length - 1].toLowerCase()

interface Props extends TagInputProps {
  fixedValues?: string[];
}

const TagInput: FC<Props> = ({ fixedValues = [], ...props }: Props) => {
  const handleOnTagRemove = (tag: string, event: React.MouseEvent) => {
    if (fixedValues.includes(tag)) {
      event.stopPropagation()
      props.onChange?.(props?.value ?? [], event)
      return
    }

    props.onTagRemove?.(tag, event)
  }

  const handleOnClean = (event: React.SyntheticEvent) => {
    if (fixedValues.length > 0) {
      event.stopPropagation()
      props.onChange?.(fixedValues, event)
      return
    }

    props.onClean?.(event)
  }

  const handleOnChange = (
    values: Readonly<string[]>,
    event: React.SyntheticEvent
  ) => {
    event.stopPropagation()
    const checkIfItemExistInValues = (item: string) => values.includes(item)

    if (
      (values.length > 0 && values[values.length - 1].trim() === '') ||
      (values.length > 1 && values.some(checkIfLastItemAlreadyExist)) ||
      (fixedValues.length > 0 && !fixedValues.every(checkIfItemExistInValues))
    ) {
      return
    }

    props.onChange?.(values, event)
  }

  return (
    <RsuiteTagInput
      trigger="Enter"
      {...props}
      onTagRemove={handleOnTagRemove}
      onClean={handleOnClean}
      onChange={handleOnChange}
    />
  )
}

export default TagInput
